import React, { useEffect } from "react";
export default function EventModal({ open, form, setForm, errors, onClose, onSubmit }) {
    useEffect(() => {
        if (!open) return;
        const onKeyDown = (e) => e.key === "Escape" && onClose();
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [open, onClose]);
    if (!open) return null;

    function handleChange(e) {
        const { name, value } = e.target;

        setForm((p) => ({ ...p, [name]: value }));
    }

    function handleImageChange(e) {
        const file= e.target.files[0];

        setForm((p) => ({ ...p, image: file }));
    }
    return (
        <div
            role="dialog"
            aria-modal="true"
            onMouseDown={ (e) => e.target === e.currentTarget && onClose() }
            style={ {
                position: "fixed",
                inset: 0,
                background: "rgb(5, 5, 5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 16,
                zIndex: 2000,
            } }
        >
            <div
                className="card admin-card"
                style={ {
                    width: "min(980px, 100%)",
                    maxHeight: "90vh",
                    overflow: "auto",
                } }
            >
                <div className="card-body p-4">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <h5 className="mb-0 text-light">
                            Create New Event
                        </h5>
                        <button className="btn btn-sm btn-outline-light" onClick={ onClose }>
                            ✕
                        </button>
                    </div>

                    <form
                        onSubmit={ (e) => {
                            e.preventDefault();
                            onSubmit();
                        } }
                    >
                        <div className="row g-3">
                            <div className="col-12 col-md-6">
                                <label className="form-label text-white">Event Title *</label>
                                <input
                                    className={ `form-control bg-dark text-light border-secondary ${errors.title ? "is-invalid" : ""
                                        }` }
                                    value={ form.title }
                                    name="title"
                                    onChange={ handleChange }
                                    placeholder="e.g. Annual Tech Summit"
                                />
                                { errors.title && (
                                    <div className="invalid-feedback">{ errors.title }</div>
                                ) }
                            </div>

                            <div className="col-12 col-md-3">
                                <label className="form-label text-white">Start Date *</label>
                                <input
                                    type="date"
                                    className={ `form-control bg-dark text-light border-secondary ${errors.startDate ? "is-invalid" : ""
                                        }` }
                                        name="startDate"
                                    value={ form.startDate }
                                    onChange={ handleChange }
                                />
                                { errors.startDate && (
                                    <div className="invalid-feedback">{ errors.startDate }</div>
                                ) }
                            </div>

                            <div className="col-12 col-md-3">
                                <label className="form-label text-white">End Date</label>
                                <input
                                    type="date"
                                    name="endDate"
                                    className={ `form-control bg-dark text-light border-secondary ${errors.endDate ? "is-invalid" : ""
                                        }` }
                                    value={ form.endDate }
                                    onChange={ handleChange }
                                />
                                { errors.endDate && (
                                    <div className="invalid-feedback">{ errors.endDate }</div>
                                ) }
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label text-white">Duration</label>
                                <input
                                name="duration"
                                    className="form-control bg-dark text-light border-secondary"
                                    value={ form.duration }
                                    onChange={ handleChange }
                                />
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label text-white">Delivery Mode</label>
                                <select
                                    className="form-control bg-dark text-light border-secondary"
                                    value={ form.delivery }
                                    onChange={ handleChange }
                                    name="delivery"
                                >
                                    <option value="">Select mode</option>
                                    <option value="In-Person">In-Person</option>
                                    <option value="Online">Online</option>
                                    <option value="Hybrid">Hybrid</option>

                                </select>
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label text-white">Is Free?</label>
                                <select
                                    className="form-select bg-dark text-light border-secondary"
                                    value={ form.isfree }
                                    onChange={ handleChange }
                                    name="isfree"
                                >
                                    <option value="0">No</option>
                                    <option value="1">Yes</option>
                                </select>
                            </div>
                            <div className="col-12 col-md-12">
                                <label className="form-label text-white">Duration</label>
                                <input
                                name=""
                                type="file"
                                accept="image/*"
                                    className="form-control bg-dark text-light border-secondary"
                                    onChange={handleImageChange }
                                />
                            </div>

                            <div className="col-12">
                                <label className="form-label text-white">Description</label>
                                <textarea
                                    rows={ 3 }
                                    name="details"
                                    className="form-control bg-dark text-light border-secondary"
                                    value={ form.details }
                                    onChange={ handleChange }
                                    placeholder="Short description..."
                                />
                            </div>
                        </div>

                        <div className="d-flex justify-content-end gap-2 mt-4">
                            <button
                                type="button"
                                className="btn btn-outline-light"
                                onClick={ onClose }
                            >
                                Cancel
                            </button>
                            <button type="submit" className="btn btn-primary">
                                Create Event
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}